'use client';

import axios from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';

import { login } from '@/services/auth/auth-api';
import { parseApiFailure } from '@/services/api/client';
import { useAuthStore } from '@/store/auth-store';
import { sanitiseInternalPath } from '@/utils/routing';
import { syncSessionCookie } from '@/utils/session-cookie';

export function useLoginMutation(redirectTo?: string | null) {
  const router = useRouter();
  const queryClient = useQueryClient();
  const setSession = useAuthStore((state) => state.setSession);

  return useMutation({
    mutationFn: login,
    onSuccess: (payload) => {
      setSession(payload);
      syncSessionCookie(true);
      toast.success('Signed in successfully.');
      router.replace(sanitiseInternalPath(redirectTo ?? null));
      void queryClient.invalidateQueries({ queryKey: ['profile'] });
      router.refresh();
    },
    onError: (error: unknown) => {
      const message = axios.isAxiosError(error)
        ? parseApiFailure(error).message
        : error instanceof Error
          ? error.message
          : 'Unable to sign in.';
      toast.error(message);
    },
  });
}
